import React from 'react';
import { type Theme, useStyletron } from 'baseui';
import type { StyleObject } from 'styletron-react';
import { CELL_WIDTH, LABEL_COLUMN_WIDTH, ROW_HEIGHT, TIMELINE_HEIGHT } from '../../constants/frame-timeline-v4';
import { TimelineGestures } from '../../providers/timeline-gestures';
import type { TimelineActionsT, TimelineRowDescriptorT } from '../../types/frame-timeline-v4';
import { TimelineDivider } from './timeline-divider';
import { TimelineGrid } from './timeline-grid';
type PropsT = {
  totalFrames: number;
  cellWidth?: number;
  rowHeight?: number;
  objectsTitle?: string;
  rows?: TimelineRowDescriptorT[];
  timelineActions?: TimelineActionsT;
};
const getContainerStyle = (theme: Theme): StyleObject => ({
  boxSizing: 'border-box',
  position: 'relative',
  width: '100%',
  height: `${TIMELINE_HEIGHT}px`,
  backgroundColor: theme.colors.backgroundPrimary,
  /* Confine the grid's internal z-index layers (sticky header, pinned column, divider)
   to this box so external content only ever stacks against the timeline as a whole. */
  isolation: 'isolate'
});
export const FrameTimeline = ({
  totalFrames,
  cellWidth = CELL_WIDTH,
  rowHeight = ROW_HEIGHT,
  objectsTitle = 'Objects',
  rows = [],
  timelineActions
}: PropsT) => {
  const [css, theme] = useStyletron();
  return <div data-testid="frame-timeline" className={css(getContainerStyle(theme))}>
      <TimelineGestures>
        <TimelineGrid totalFrames={totalFrames} cellWidth={cellWidth} rowHeight={rowHeight} objectsTitle={objectsTitle} rows={rows} timelineActions={timelineActions} />
      </TimelineGestures>
      <TimelineDivider left={LABEL_COLUMN_WIDTH} />
    </div>;
};